import { render, staticRenderFns } from "./user_change.vue?vue&type=template&id=6e237490&scoped=true&"
import script from "./user_change.vue?vue&type=script&lang=js&"
export * from "./user_change.vue?vue&type=script&lang=js&"
import style0 from "./user_change.vue?vue&type=style&index=0&id=6e237490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e237490",
  null
  
)

export default component.exports